import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardService } from '../dashboard.service';
import { TranslateService } from '../../../services/translate.service';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  standalone: true,
  selector: 'app-created-suppliers-widget',
  imports: [CommonModule],
  templateUrl: './supplier-counter-widget.component.html',
  styleUrls: ['./supplier-counter-widget.component.scss']
})
export class UploadedSuppliersWidgetComponent implements OnInit {

  @Input() callerName?: string;

  @Input() inDialog = false; // not used here, kept for compatibility

  totalSuppliers: number | null = null;
  lastMonthSuppliers: number | null = null;
  allApiData: Record<string, any[]> = {};

  loading = false;
  error: string | null = null;

  constructor(private dashboardService: DashboardService, public translateServ: TranslateService) {}

  ngOnInit(): void {
	const caller = this.callerName ?? this.constructor.name.substring(1);
	this.loadData(caller);
  }

  loadData(caller: string) {
	this.loading = true;
	this.error = null;

	this.dashboardService.getExtendedData(caller)
	  .pipe(
		catchError(err => {
		  console.error('UploadedSuppliersWidget - API error', err);
		  this.error = 'Failed to load';
		  this.loading = false;
		  return of(null);
		})
	  )
	  .subscribe((data: any) => {
		this.loading = false;
		if (!data) return;
		this.allApiData = data;
		
		// Fill values according to the API structure you posted earlier
		this.totalSuppliers = data?.Table?.[0]?.TotalSuppliers ?? 0;

		// Use Table3 for last month's data
		this.lastMonthSuppliers = data?.Table3?.[0]?.Total_Suppliers_in_Current_Month ?? 0;
	  });
  }
}
